import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class Sandbox extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'sandbox';
    }
    getDirectiveType() {
        return DirectiveType.Document;
    }
}
